<template>
  <a
    class="event__wrapper"
    :data-cy="'eventLink' + event.id"
    :href="
      isExternalEvent
        ? localePath(`/${provider}/${event.id}`)
        : localePath(
            `/${event.tenantName}/event/${event.id}/${event.name.replace(/[^a-zA-Z0-9-_]/g, '-').replace(/-+/gi, '-')}`
          )
    "
  >
    <div class="event">
      <div class="event__content">
        <div class="event__poster">
          <img
            v-if="event.mainImageUri"
            :src="eventImage"
            alt="Banner"
            loading="lazy"
            data-cy="eventImage"
            @error="thumbnailFound = false"
          />
          <img v-else :src="placeholderImage" alt="Banner" loading="lazy" />
        </div>
        <div class="event__content-title">
          <h2>{{ event.name }}</h2>
        </div>
        <div v-if="event.startAt" class="event__content-date">
          <IconCalendar color="lighten2" />
          <p>
            {{ formatEventDate(event) }}
          </p>
        </div>
        <div class="event__content-location">
          <IconLocation color="lighten2" />
          <p>
            {{ event.venue.address.street1 }}, {{ event.venue.address.zip }}
            {{ event.venue.address.city }}, {{ event.venue.address.country }}
          </p>
        </div>
      </div>
    </div>
  </a>
</template>
<script>
import IconCalendar from '@/components/general/icons/IconCalendar';
import IconLocation from '@/components/general/icons/IconLocation';
import { EVENT_TYPES } from '~/utils/utils';
import { convertDateToDisplay } from '~/utils/date-time';
export default {
  name: 'BEvent',
  components: { IconCalendar, IconLocation },
  props: {
    event: {
      type: Object,
      default() {
        return {};
      }
    },
    provider: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      eventTypes: EVENT_TYPES,
      thumbnailFound: true
    };
  },
  computed: {
    eventImage() {
      if (this.thumbnailFound && this.event.mainImageUri) {
        // This also has a handy side effect of not affecting images not hosted by us,
        // if you specify them like that during the event creation
        return this.event.mainImageUri.replace('16x9', '16x9/thumbnail');
      }
      return this.event.mainImageUri;
    },
    backgroundImage() {
      return {
        'background-image': `url(${this.event.mainImageUri})`
      };
    },
    isExternalEvent() {
      return this.event.type === this.eventTypes.EXTERNAL;
    },
    placeholderImage() {
      return this.isExternalEvent
        ? require('assets/img/featured_event.webp')
        : require('assets/img/event_placeholder.webp');
    }
  },
  methods: {
    formatEventDate(event) {
      const startDate = convertDateToDisplay(event.startAt, event.timezoneName);
      const endDate = convertDateToDisplay(event.endAt, event.timezoneName);
      return `${this.$d(startDate, 'ddd_DD_MMM_YYYY_HH_mm')} - ${this.$d(endDate, 'HH_mm')}`;
    }
  }
};
</script>
